import * as types from '@/constants/mutationTypes'

const state = {
  emailReportsList: []
}
const getters = {
  emailReportsList: state => state.emailReportsList
}
const actions = {
  setEmailReportsList ({commit}, data) {
    commit(types.SET_EMAIL_REPORTS_LIST, {data})
  }
}
const mutations = {
  [types.SET_EMAIL_REPORTS_LIST] (state, {data}) {
    state.emailReportsList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/EmailReports/modules/store.js